const PERSON_GROUP = {
	title: 'agents',
	type: 'title'
};
const OFFICE_GROUP = {
	title: 'offices',
	type: 'title'
};
const OC_PAGE_URL = '/iroda-kereso';

export const officeAndAdvisorComponent = {
	bindings: {
		onSelectFromList: '&',
		niceUrlSearchText: '<',
		onSuccessSearchByMap: '&'
	},
	templateUrl: 'office-and-advisor-search-page.html',
	controller: class officeAndAdvisorComponent {
		constructor($http, $timeout, $scope, $element, $compile, $q, SearchService, $rootScope, loaderService) {
			'ngInject';
			this.$http = $http;
			this.$timeout = $timeout;
			this.$scope = $scope;
			this.resultList = [];
			this.$q = $q;
			this.searchService = SearchService;
			this.$rootScope = $rootScope;
			this.showNoResult = false;
			this.showNoOfficeOrPerson = false;
			this.loaderService = loaderService;
		}

		$onInit() {
			if (!this.initialized) {
				if (window.location.hash) {
					this.searchText = this.niceUrlSearchText;
					if (window.localStorage.getItem('fromFooter')) {
						window.localStorage.removeItem('fromFooter');
						this.searchAsPlace(this.searchText);
					} else {
						this.querySearch(this.searchText);
						this.$timeout(() => {
							angular.element('input[type=search]')[0].focus();
						});
					}
				}
				this.initialized = true;
			}
		}

		$onChange(change) {
			if (change.niceUrlSearchText) {
				this.$onInit();
			}
		}

		querySearch(searchText) {
			this.showNoResult = false;
			this.showNoOfficeOrPerson = false;
			window.location.hash = '#/kereses=' + searchText + '/view=list';
			if (searchText.length < 3) {
				return;
			}
			this.loaderService.show();
			this.searchText = searchText;
			let params = {
				search: searchText
			};
			return this.$http({
				method: 'GET',
				url: '/public/agents-and-offices/search',
				params: params
			}).then((response) => {
				// Mock
				// response = mockResponse;
				this.loaderService.hide(500);
				this.locations = response.data.offices;
				this.agents = response.data.agents;
				this.resultList = this.transformResponse(this.locations, this.agents);
				if (this.resultList.length) {
					return this.$q.resolve(this.resultList);
				} else {
					this.showNoOfficeOrPerson = true;
				}
			}).catch((error) => {
				this.loaderService.hide(500);
				console.log(error);
				return this.$q.reject(this.resultList);
			});
		}

		searchAsPlace(searchText) {
			this.showNoResult = false;
			this.showNoOfficeOrPerson = false;
			let params = {
				search: searchText
			};
			return this.$http({
				method: 'GET',
				url: '/public/agents-and-offices/searchByMap',
				params: params
			}).then((response) => {
				// Mock
				// response = mockSearchByMapResponse;

				if (Array.isArray(response.data) && response.data.length) {
					this.resultListByMap = this.transformResponseByMap(response.data);
					this.onSuccessSearchByMap({
						$event: {
							resultListByMap: this.resultListByMap
						}
					});
				} else {
					this.showNoResult = true;
				}
			}).catch((error) => {
				console.log(error);
			});
		}

		transformResponse(locations, agents) {
			let retvalue = [];
			if (Array.isArray(agents) && agents.length) {
				retvalue.push(PERSON_GROUP);
				for (let i = 0; i < agents.length; i++) {
					agents[i].type = 'person';
					retvalue.push(agents[i]);
				}
			}
			if (Array.isArray(locations) && locations.length) {
				retvalue.push(OFFICE_GROUP);
				for (let i = 0; i < locations.length; i++) {
					locations[i].type = 'office';
					retvalue.push(locations[i]);
				}
			}
			return retvalue;
		}

		transformResponseByMap(arr) {
			let retvalue = [];
			for (let i = 0; i < arr.length; i++) {
				arr[i].type = 'office';
				retvalue.push(arr[i]);
			}
			return retvalue;
		}

		titleClick($event) {
			$event.preventDefault();
			$event.stopPropagation();
		}

		selectItem(item, searchText, fromSearchButton) {
			if (item && item.type == 'title') {
				return;
			}
			if (fromSearchButton) {
				this.querySearch(searchText);
			} else {
				// az oldalon választ
				window.location.hash = '#/kereses=' + searchText + '/view=list';
				this.onSelectFromList({
					$event: {
						listElement: item
					}
				});
			}
		}

		search(searchText) {
			if (searchText) {
				this.selectItem(null, searchText, true);
			}
		}
	}
};
